import { render, staticRenderFns } from "./order-modal.vue?vue&type=template&id=1fc991f3"
import script from "./order-modal.vue?vue&type=script&lang=js"
export * from "./order-modal.vue?vue&type=script&lang=js"
import style0 from "./order-modal.vue?vue&type=style&index=0&id=1fc991f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports